import React  from "react";
import { useParams } from 'react-router-dom';
import SalaryAdjustmentForm from "./components/SalaryAdjustmentForm";
import PayrunSalaryAdjustmentTable from "./components/PayrunSalaryAdjustmentTable";

const ViewSalaryAdjustment = () => {
	const { adjustmentId } = useParams();
    
	return (
	    <div className="mt-5">
      		<SalaryAdjustmentForm recordId={adjustmentId} mode="view"/>
      		
      		<PayrunSalaryAdjustmentTable className="mt-5"/>
	    </div>
    );
};

export default ViewSalaryAdjustment;